import { Component, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import {
  DEFAULT_SEARCH_STATE,
  SearchStateService,
} from '../../../research/services/search-state.service'
import {
  FacetButtonItem,
  FacetButtonType,
} from '../facet-buttons/facet-buttons.component'

export interface AllFiltersItem {
  category: string
  label: string
  type: 'term' | 'filter' | 'library'
  filterData?: {
    type: string
    filter: string
  }
}

@Component({
  standalone: false,
  selector: 'cyborg-all-active-filters',
  templateUrl: './all-active-filters.component.html',
  styleUrls: ['./all-active-filters.component.scss'],
})
export class AllActiveFiltersComponent implements OnInit {
  searchStateService = inject(SearchStateService)

  public allFilters$: Observable<FacetButtonItem[]>

  public ngOnInit(): void {
    this.allFilters$ = this.searchStateService.state.pipe(
      map((state) => {
        const allFilters: FacetButtonItem[] = state.filtersDenormalized.map(
          (filter) => {
            return {
              type: FacetButtonType.tag,
              category: filter.type,
              value: filter.filter,
            }
          },
        )

        if (
          state.library &&
          state.library !== DEFAULT_SEARCH_STATE.library &&
          state.touched
        ) {
          state.library.forEach((lib) => {
            allFilters.unshift({
              type: FacetButtonType.library,
              value: lib,
            })
          })
        }

        if (state.term && state.term.length > 0) {
          state.term.forEach((term) => {
            allFilters.unshift({
              type: FacetButtonType.term,
              value: term,
            })
          })
        }

        return allFilters
      }),
    )
  }

  public onClearAllFilters(): void {
    this.searchStateService.reset()
    document.querySelectorAll('aside input[type="radio"]').forEach((radio) => {
      ;(radio as HTMLInputElement).checked = false
    })
  }
}
